/// <reference types="facebook-js-sdk" />
import { Environment } from "@core/config/environment";
import { objectToGetParams } from "@utils/link";
import { FacebookService } from "./facebookService";

export class BrowserFacebookService implements FacebookService {
	constructor() {
		// The FB SDK requires a 'window.fbAsyncInit' method to load.
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(window as any).fbAsyncInit = function () {
			FB.init({
				appId: Environment.FACEBOOK_APP_ID,
				cookie: false,
				xfbml: true,
				version: "v8.0",
			});
		};

		(function (d, s, id) {
			const fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				return;
			}
			const js = d.createElement(s) as HTMLScriptElement;
			js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			if (fjs.parentNode !== null) {
				fjs.parentNode.insertBefore(js, fjs);
			}
		})(document, "script", "facebook-jssdk");
	}

	async openShareDialog(url: string): Promise<void> {
		return new Promise(function () {
			window.open("https://www.facebook.com/sharer/sharer.php" + objectToGetParams({ u: url }));
		});
		// return new Promise(function (resolve, reject) {
		// 	FB.ui(
		// 		{
		// 			method: "share",
		// 			mobile_iframe: true,
		// 			quote: text,
		// 			href: url,
		// 		},
		// 		(response) => {
		// 			if (response?.error_code !== undefined) {
		// 				reject(response);
		// 			} else {
		// 				resolve();
		// 			}
		// 		}
		// 	);
		// });
	}
}
